<textarea [(ngModel)]="value" (ngModelChange)="emitChange()" [placeholder]="placeholder" [attr.data-cy]="dataLabel"
	(keyup)="keyUp($event)" (blur)="blur()" [disabled]="disabled" class="form-control" [attr.id]="id ? id : ''"
	[attr.maxLength]="styles?.maxLength ? styles.maxLength : ''" [rlGetFocus]="focused$"
	[style.width.px]="styles?.width ? styles.width : ''" [style.height.px]="styles?.height ? styles.height : ''"
	[attr.aria-label]="value + ' Text Field'"></textarea>
@if (showCounter) {
	<div class="d-flex align-items-center">
		<span class="text-small text-muted ms-2">{{ contentLength }}/{{ styles?.maxLength }}</span>
	</div>
}